/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateGrantsControllerFindAllQueryResponse, TemplateGrantsControllerFindAllQueryParams, TemplateGrantsControllerFindAll401, TemplateGrantsControllerFindAll403 } from "../../models/checklistsController/TemplateGrantsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { templateGrantsControllerFindAll } from "../../clients/checklistsService/templateGrantsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const templateGrantsControllerFindAllQueryKey = (params: TemplateGrantsControllerFindAllQueryParams) => [{
  url: '/api/v1/checklist-template-grants'
}, ...(params ? [params] : [])] as const;
export type TemplateGrantsControllerFindAllQueryKey = ReturnType<typeof templateGrantsControllerFindAllQueryKey>;
export function templateGrantsControllerFindAllQueryOptions(params: TemplateGrantsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = templateGrantsControllerFindAllQueryKey(params);
  return queryOptions<TemplateGrantsControllerFindAllQueryResponse, ResponseErrorConfig<TemplateGrantsControllerFindAll401 | TemplateGrantsControllerFindAll403>, TemplateGrantsControllerFindAllQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return templateGrantsControllerFindAll(params, config);
    }
  });
}

/**
 * @summary List granted templates for a scope
 * {@link /api/v1/checklist-template-grants}
 */
export function useTemplateGrantsControllerFindAll<TData = TemplateGrantsControllerFindAllQueryResponse, TQueryData = TemplateGrantsControllerFindAllQueryResponse, TQueryKey extends QueryKey = TemplateGrantsControllerFindAllQueryKey>(params: TemplateGrantsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<TemplateGrantsControllerFindAllQueryResponse, ResponseErrorConfig<TemplateGrantsControllerFindAll401 | TemplateGrantsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? templateGrantsControllerFindAllQueryKey(params);
  const query = useQuery({
    ...templateGrantsControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TemplateGrantsControllerFindAll401 | TemplateGrantsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}